import React from "react";
import * as yup from "yup";
import Swal from "sweetalert2";
import AppForm from "../../../../partials/content/Forms/AppForm";
import ConfirmUploadedCustomers from "./confirmUploadedCustomers";
import ConfirmUploadedLeads from "./confirmUploadedLeads";
import ConfirmUploadedOutlets from "./confirmUploadedOutlets";
import ConfirmUploadedWarehouses from "./confirmUploadedWarehouses";
import ConfirmUploadedItems from "./confirmUploadedItems";
import ConfirmUploadedVendors from "./confirmUploadedVendors";
import ConfirmUploadedUsers from "./confirmUploadedUsers";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import { saveUploadedMassUpload } from "../../../../services/commons";
const massUploadsSchema = () => {
  return yup.array().of(
    yup.object().shape({
      massUploadFor: yup.number(),
    })
  );
};
function ConfirmUploadedMassUploadForm({
  uploadedMassUploads = [],
  appCode,
  appCodeDesc,
  onOpenUploadFile,
  onConfirmSave,
  handleRefreshUploadedMassUpload,
  history,
}) {
  const actionButtons = [
    {
      title: "",
      color: "label-brand",
      icon: "fas fa-backward",
      onClick: () => {
        history.push("/menu");
      },
    },
  ];
  actionButtons.push({
    title: "New Mass Upload",
    color: "primary",
    icon: "fas fa-plus-circle",
    onClick: () => {
      onOpenUploadFile();
      handleRefreshUploadedMassUpload();
    },
  });

  return (
    <React.Fragment>
      <PageSubHeader
        title={
          uploadedMassUploads && uploadedMassUploads.length > 0
            ? `Mass Upload ${appCodeDesc}`
            : `Mass Upload`
        }
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/common/mass-upload",
            title: `${
              uploadedMassUploads && uploadedMassUploads.length > 0
                ? `Mass Upload ${appCodeDesc}`
                : `Mass Upload`
            }`,
            active: true,
          },
        ]}
        actionButtons={actionButtons}
      />
      <AppForm
        initialValues={uploadedMassUploads}
        validationSchema={massUploadsSchema}
        onSubmit={async (values, { setStatus, setSubmitting }) => {
          /*Only process data with status Ready To Upload*/
          const readyToUpload = values.filter(function(row) {
            return row.statusID === 1;
          });
          if (readyToUpload.length > 0) {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            })
              .fire({
                title:
                  "Are you sure want to save this " +
                  appCodeDesc +
                  " mass upload ?",
                text:
                  "Please note that you are responsible for this action. Only data with status Ready To Upload will be processed",
                icon: "question",
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
                cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
                reverseButtons: true,
              })
              .then((result) => {
                if (result.isConfirmed) {
                  saveUploadedMassUpload(appCode, values).then((response) => {
                    Swal.mixin({
                      customClass: {
                        confirmButton:
                          "btn btn-success btn-md btn-pill btn-bold",
                      },
                      buttonsStyling: false,
                    }).fire({
                      title: "Saved",
                      html: response.data.message,
                      icon: "success",
                      showCloseButton: true,
                      confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                    });
                    const { data } = response.data;
                    onConfirmSave(data);
                  });
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Cancelled",
                    text: "No change has been made",
                    icon: "info",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                }
              });
          } else {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Failed",
              text: "You don't have data which has Ready To Upload status",
              icon: "error",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
          }
        }}
      >
        {appCode === "CUST" ? (
          <ConfirmUploadedCustomers />
        ) : appCode === "LEAD" ? (
          <ConfirmUploadedLeads />
        ) : appCode === "OUTL" ? (
          <ConfirmUploadedOutlets />
        ) : appCode === "WARE" ? (
          <ConfirmUploadedWarehouses />
        ) : appCode === "ITEM" ? (
          <ConfirmUploadedItems />
        ) : appCode === "VEND" ? (
          <ConfirmUploadedVendors />
        ) : appCode === "USER" ? (
          <ConfirmUploadedUsers />
        ) : null}
      </AppForm>
    </React.Fragment>
  );
}

export default ConfirmUploadedMassUploadForm;
